<div class="converted-files-wrapper">
  <div class="converted-files-header">
    <p class="converted-files-title">
      <span class="material-symbols-rounded folder-icon">folder</span>
      {{ "admin.convertedFiles.title" | translate }}
    </p>

    <div class="converted-files-controls">
      <!-- Search input -->
      <div class="converted-files-search">
        <input
          #filter
          (input)="onSearchChange(filter.value)"
          [placeholder]="'admin.convertedFiles.searchPlaceholder' | translate"
          type="text"
        />
        <span class="material-symbols-rounded text-base">search</span>
      </div>

      <!-- Date Picker -->
      <div class="relative w-52">
        <input
          (change)="onDateRangeChange($event)"
          [(ngModel)]="selectedDates"
          [alwaysShowCalendars]="true"
          [autoApply]="true"
          [linkedCalendars]="true"
          [locale]="datepickerLocale"
          [placeholder]="'admin.convertedFiles.dateFilter' | translate"
          [showCancel]="false"
          [showClearButton]="true"
          [showDropdowns]="true"
          class="form-control cursor-pointer w-full border rounded text-sm"
          ngxDaterangepickerBootstrap
          readonly
          type="text"
        />
        <div
          class="absolute inset-y-0 right-2 flex items-center pointer-events-none"
        >
          <span class="material-symbols-rounded scale-75 text-[#6A7381]"
            >date_range</span
          >
        </div>
      </div>

      <!-- Dropdown -->
      <app-multi-select-dropdown
        (selectedChange)="onFileTypeChange($event)"
        [(selected)]="selectedFileType"
        [label]="'admin.convertedFiles.fileType' | translate"
        [multiple]="false"
        [options]="fileTypeOptions"
      />

      @if (environment.isSuperAdmin) {
        <app-multi-select-dropdown
          (searchSubmitted)="onCompanySearch($event)"
          (selectedChange)="onCompanyChange($event)"
          [(selected)]="selectedCompanies"
          [label]="'admin.convertedFiles.company' | translate"
          [multiple]="true"
          [options]="companyOptions"
          [placeholder]="'admin.convertedFiles.searchCompanies' | translate"
          [searchable]="true"
        />
      }

      @if (isFilterApplied$ | async) {
        <button
          (click)="clearFilters()"
          class="text-sm text-[#6A7381] hover:underline"
        >
          {{ "admin.convertedFiles.clearFilters" | translate }}
        </button>
      }
    </div>
  </div>

  <!-- Table -->
  <div class="converted-files-table-wrapper">
    <div class="converted-files-table-outer">
      <table class="converted-files-table">
        <thead>
          <tr class="table-header-row">
            <th (click)="onSort('originalFileName')" class="cursor-pointer">
              {{ "admin.convertedFiles.table.fileName" | translate }}
              @if (sortColumn === "originalFileName") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th (click)="onSort('fileType')" class="cursor-pointer">
              {{ "admin.convertedFiles.table.type" | translate }}
              @if (sortColumn === "fileType") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th (click)="onSort('createdAt')" class="cursor-pointer">
              {{ "admin.convertedFiles.table.convertedAt" | translate }}
              @if (sortColumn === "createdAt") {
                <span>{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
              }
            </th>

            <th
              (click)="onSort('userName')"
              class="cursor-pointer select-none whitespace-nowrap text-left"
            >
              {{ "admin.convertedFiles.table.convertedBy" | translate }}
              <span class="inline-block w-4 text-xs text-gray-500">
                @if (sortColumn === "userName") {
                  {{ sortDirection === "asc" ? "▲" : "▼" }}
                }
              </span>
            </th>
            @if (environment.isSuperAdmin) {
              <th
                (click)="onSort('companyName')"
                class="cursor-pointer select-none whitespace-nowrap text-left"
              >
                {{ "admin.convertedFiles.table.company" | translate }}
                <span class="inline-block w-4 text-xs text-gray-500">
                  @if (sortColumn === "companyName") {
                    {{ sortDirection === "asc" ? "▲" : "▼" }}
                  }
                </span>
              </th>
            }
          </tr>
        </thead>

        @if (convertedFiles$ | async; as files) {
          <tbody>
            @for (file of files.items; track $index) {
              <tr class="table-row">
                <td>{{ file.originalFileName }}</td>
                <td>
                  <span
                    class="file-type-label"
                    [ngClass]="{
                      '!bg-[#E6F1FA] !text-[#0069BC]':
                        file.fileType === 'Gerber',
                      '!bg-[#FEF0F2] !text-[#853844]':
                        file.fileType === 'Lectra',
                    }"
                  >
                    {{ file.fileType }}
                  </span>
                </td>
                <td>{{ dateUtils.formatIsoToDateTime(file.createdAt) }}</td>
                <td>{{ file.userName }}</td>
                @if (environment.isSuperAdmin) {
                  <td>{{ file.companyName }}</td>
                }
              </tr>
            }
          </tbody>
        }
      </table>
    </div>

    <div class="pagination">
      @if (convertedFiles$ | async; as files) {
        <app-pagination
          [currentPage]="files.page"
          [totalPages]="files.totalPages"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
        />
      }
    </div>
  </div>
</div>
